import { useUserStore, userStoreSelector } from '../../stores/userStore';

import { FadeIn } from './styles';
import { WithAuthProps } from './types';

/**
 * This is a wrapper for the user navigation in the header.
 * It displays a navigation for logged in users and authentication options for
 * users that are not logged in.
 */
const WithAuth: React.FC<WithAuthProps> = ({
  renderAuth,
  renderUnauth,
  disableAnimation,
  onLogout,
}) => {
  const user = useUserStore(userStoreSelector.loadingUser);
  const handleLogout = async (): Promise<void> => {
    await useUserStore.getState().logout();
    onLogout?.();
  };

  return (
    <FadeIn enabled={!disableAnimation}>
      {renderUnauth && user === null && renderUnauth()}
      {user && renderAuth(user, handleLogout)}
    </FadeIn>
  );
};

export default WithAuth;
